import { render } from "./AI1.vue?vue&type=template&id=0e64635b&scoped=true"
import script from "./AI1.vue?vue&type=script&lang=js"
export * from "./AI1.vue?vue&type=script&lang=js"

import "./AI1.vue?vue&type=style&index=0&id=0e64635b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e64635b"]])

export default __exports__